import { Button as UIButton } from "@wb/ui/components/button";
import { cn } from "@wb/ui/lib/utils";
import type { ComponentProps } from "react";

export const Button = ({
  className,
  ...props
}: ComponentProps<typeof UIButton>) => {
  return (
    <UIButton
      type="button"
      className={cn(className, "cursor-pointer select-none")}
      {...props}
    />
  );
};
